import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { UserQueryKeys, UserWithCompanies } from '~/types/user';
import { backendApiGateway } from '../client/backend';

interface IntercomTokenResponse {
  token: string;
}

const generateIntercomToken = async (): Promise<string> => {
  const {
    data: { token },
  } = await backendApiGateway.get<{}, AxiosResponse<IntercomTokenResponse>>('api/v1/users/chat-token', {
    headers: {
      Accept: 'application/json',
    },
  });
  return token;
};

export const useIntercomToken = (userData?: UserWithCompanies) => {
  return useQuery({
    queryKey: UserQueryKeys.intercomToken,
    queryFn: generateIntercomToken,
    enabled: !!userData,
  });
};
